<template>
    <BaseForm>
        <template #fields>
            <MultiLink
                :label="$t('extra-documents')"
                :links="values.extraDocuments"
                :error-messages="errors.extraDocuments"
                @input="setFieldValue('extraDocuments', $event)"
                @delete="setFieldValue('extraDocuments', $event)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import { useMultiLink } from '@/components/MultiLink/composables/useMultiLink';
import MultiLink from '@/components/MultiLink/MultiLink.vue';
import { useEventSeriesInjection } from '@/event/composables/useEventSeriesInjection';
import { useForm } from '@/forms/composables/useForm';
import { computed } from 'vue';
import { EventSeriesDocumentsSchema } from '../schemas';

defineProps<{ seriesId: string }>();

const { series, createEventSeriesMultiLink } = useEventSeriesInjection();
const { getFormFieldLinks, saveMultiLinkFields } = useMultiLink(createEventSeriesMultiLink);

const extraDocumentsId = computed(() => series.value?.extraDocuments?.id);
const extraDocumentsLinks = computed(() => series.value?.extraDocuments?.links.nodes ?? []);

const { errors, values, setFieldValue, validate, onDiscard, resetForm } = useForm(
    EventSeriesDocumentsSchema,
    computed(() => ({
        extraDocuments: getFormFieldLinks(extraDocumentsLinks),
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await saveMultiLinkFields([
            { id: extraDocumentsId.value, fieldName: 'extraDocuments', links: values.value.extraDocuments },
        ]);
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
